import React from "react";
import Footer from "../Components/Footer/Footer";
import Terms from "../Components/Terms/Terms";
import TopHeader from "../Components/TopHeader/TopHeader";
import Menu from "./../Components/Header/Menu";

function TermsCondition() {
  return (
    <>
      <TopHeader />
      <Menu />
      <Terms />
      <Footer />
    </>
  );
}

export default TermsCondition;
